// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReForm from "../../reform/ReForm.bs.jsx";
import * as DialogForm from "../../components/DialogForm/DialogForm.bs.jsx";
import * as Validators from "../../utils/Validators.bs.jsx";
import * as InputWrapper from "../../components/InputWrapper/InputWrapper.bs.jsx";
import * as ReForm__Helpers from "../../reform/ReForm__Helpers.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";

function get(state, field) {
  return state.name;
}

function set(_state, field, value) {
  return {
    name: value
  };
}

let FormFields = {
  get: get,
  set: set
};

let Form = ReForm.Make({
  set: set,
  get: get
});

let Validators$1 = Validators.CustomValidators({
  set: set,
  get: get
});

function TapAddNew(props) {
  let onSubmit = props.onSubmit;
  let form = Form.use({
    name: ""
  }, Validators$1.schema([
    Validators$1.required("Name"),
    Validators$1.notIn(props.existingNames, "Tato pípa již existuje", "Name")
  ]), param => {
    onSubmit(param.state.values);
  }, undefined, undefined, "OnDemand", undefined);
  let maybeErrorMessage = form.state.formState;
  let tmp;
  if (typeof maybeErrorMessage !== "object") {
    tmp = null;
  } else {
    let maybeErrorMessage$1 = maybeErrorMessage._0;
    tmp = maybeErrorMessage$1 !== undefined ? maybeErrorMessage$1 : "Neznámá chyba";
  }
  return <DialogForm.make
    formId={"addTap"}
    heading={"Přidat pípu"}
    onDismiss={props.onDismiss}
    visible={true}
  >
    <Form.Provider.make
      value={form}
    >
      <form
        id={"addTap"}
        onSubmit={ReForm__Helpers.handleSubmit(form.submit)}
      >
        <fieldset
          className={"reset"}
        >
          <Form.Field.make
            field={"Name"}
            render={field => <InputWrapper.make
              inputError={field.error}
              inputName={"name"}
              inputSlot={<input
                type={"text"}
                value={field.value}
                onChange={ReForm__Helpers.handleChange(field.handleChange)}
              />}
              labelSlot={"Označení"}
            />}
          />
        </fieldset>
      </form>
      {tmp}
    </Form.Provider.make>
  </DialogForm.make>;
}

let make = TapAddNew;

export {
  FormFields,
  Form,
  Validators$1 as Validators,
  make,
}
/* Form Not a pure module */
